import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";

const initialState = {
  categories: [],
  activeCategory: null,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setActiveCategory: (state, action) => {
      state.activeCategory = action.payload;
    },
  },
});

export const getCategories = (
  state: RootState,
  initialCategories: any = []
) => {
  return state.category.categories || initialCategories;
};

export const getActiveCategory = (
  state: RootState,
  initialActiveCategory: string = null
) => {
  return state.category.activeCategory || initialActiveCategory;
};

export const { setActiveCategory, setCategories } = categorySlice.actions;
export default categorySlice.reducer;
